import { useSearchParams } from 'react-router-dom';
import useSyncRequestedEvent from './useSyncRequestedEvent';

export const useSyncRequested = () => {
  const [searchParams] = useSearchParams();
  return useSyncRequestedEvent(searchParams);
};
